import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpRuntimeStartGasDayOrAfterValidator
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * If runtime start is in the past, the value is invalid
     *
     * @attr {{start: Date, end: Date}} ngModel
     * @attr {boolean} startGasDayOrAfterValidatorActive
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive(
            'pkpRuntimeStartGasDayOrAfterValidator',
            pkpRuntimeStartGasDayOrAfterValidator
        );

    function pkpRuntimeStartGasDayOrAfterValidator(utilService: UtilService) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpRuntimeStartGasDayOrAfterValidator =
                validate;

            function validate(modelValue) {
                if (!modelValue || !modelValue.start) {
                    return true;
                }

                if (
                    angular.isDefined(attr.startGasDayOrAfterValidatorActive) &&
                    !scope.$eval(attr.startGasDayOrAfterValidatorActive)
                ) {
                    return true;
                }

                var todayGasDayStart = utilService.getCurrentGasDayStart();
                var runtimeStart = moment(modelValue.start);

                return runtimeStart.isSameOrAfter(todayGasDayStart, 'minute');
            }
        }
    }
})();
